(() => {
  const checkoutUrl = (variantId) => `/cart/${variantId}:1?checkout`;

  function initWhatsApp(root = document) {
    root.querySelectorAll('[data-cw-whatsapp]').forEach((link) => {
      const number = (link.dataset.whatsappNumber || '').replace(/\D/g, '');
      const message = link.dataset.whatsappMessage || '';
      if (!number) {
        link.setAttribute('aria-disabled', 'true');
        link.addEventListener('click', (event) => event.preventDefault(), { once: true });
        return;
      }
      link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    });
  }

  function initCheckout(root = document) {
    root.querySelectorAll('[data-cw-checkout]:not([data-cw-ready])').forEach((button) => {
      button.dataset.cwReady = 'true';
      const sync = () => {
        const variantId = button.dataset.variantId;
        button.href = variantId ? checkoutUrl(variantId) : '#';
        button.setAttribute('aria-disabled', variantId ? 'false' : 'true');
      };
      sync();
      button.addEventListener('click', (event) => {
        if (!button.dataset.variantId) {
          event.preventDefault();
          window.alert('Selecciona el producto de abono en el editor de esta sección antes de publicar.');
        }
      });
    });
  }

  function initAcceleration(root = document) {
    root.querySelectorAll('[data-cw-acceleration]:not([data-cw-ready])').forEach((section) => {
      section.dataset.cwReady = 'true';
      const options = section.querySelectorAll('[data-cw-acceleration-option]');
      const button = section.querySelector('[data-cw-acceleration-checkout]');
      const plan = section.querySelector('[data-cw-plan]');
      const total = section.querySelector('[data-cw-total]');
      const deposit = section.querySelector('[data-cw-deposit]');

      const update = (option, emitTracking = false) => {
        if (!option || !button) return;
        const withVideos = option.value === 'videos';
        options.forEach((input) => input.closest('.cw-option')?.classList.toggle('is-selected', input === option));
        if (plan) plan.textContent = option.dataset.plan;
        if (total) total.textContent = option.dataset.price;
        if (deposit) deposit.textContent = `${withVideos ? 'Abono inicial 50%' : 'Comienza abonando el 50%'}: ${option.dataset.deposit}`;
        button.textContent = `${button.dataset.buttonLabel} — ${option.dataset.deposit}`;
        button.dataset.variantId = option.dataset.variantId || '';
        button.href = option.dataset.variantId ? checkoutUrl(option.dataset.variantId) : '#';
        button.setAttribute('aria-disabled', option.dataset.variantId ? 'false' : 'true');
        if (emitTracking) {
          document.dispatchEvent(new CustomEvent('cw:tracking', { detail: { event: 'acceleration_option_change', option: option.value } }));
        }
      };

      options.forEach((option) => option.addEventListener('change', () => update(option, true)));
      update(section.querySelector('[data-cw-acceleration-option]:checked'));
    });
  }

  function initFaq(root = document) {
    root.querySelectorAll('[data-cw-faq-button]:not([data-cw-ready])').forEach((button) => {
      button.dataset.cwReady = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.cw-faq-item');
        const list = item?.parentElement;
        const willOpen = !item?.classList.contains('is-open');
        list?.querySelectorAll('.cw-faq-item.is-open').forEach((openItem) => {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-cw-faq-button]')?.setAttribute('aria-expanded', 'false');
        });
        item?.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });
  }

  function init(root = document) {
    initWhatsApp(root);
    initCheckout(root);
    initAcceleration(root);
    initFaq(root);
    root.querySelectorAll('[data-cw-year]').forEach((node) => { node.textContent = new Date().getFullYear(); });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
